export const GET_GOVT_ORDERS_REQUEST = "GET_GOVT_ORDERS_REQUEST";
export const GET_GOVT_ORDERS_SUCCESS = "GET_GOVT_ORDERS_SUCCESS";
export const GET_GOVT_ORDERS_FAILURE = "GET_GOVT_ORDERS_FAILURE";
